import { useSyncExternalStore } from "react";
import { useExtracted } from "next-intl";
import { emit } from "@/lib/event-bus";

const noop = () => () => {};
const getModKey = () =>
  /Mac|iPhone|iPad/.test(navigator.userAgent) ? "\u2318" : "Ctrl";
const getServerModKey = () => "Ctrl";

export function AskAITrigger() {
  const te = useExtracted();
  const modKey = useSyncExternalStore(noop, getModKey, getServerModKey);
  const ASK_AI_LABEL = te("Ask AI");

  return (
    <button
      aria-label={ASK_AI_LABEL}
      className="group text-muted-foreground md:border-border md:bg-surface md:hover:bg-surface-raised flex h-7.75 w-7.75 cursor-pointer items-center justify-center gap-2 rounded-lg p-0 text-xs transition-colors hover:brightness-125 md:h-10 md:w-auto md:min-w-48 md:justify-start md:border md:px-3 md:hover:brightness-100"
      type="button"
      onClick={() => emit("ai-assistant:open")}
    >
      <img
        src="/guide-manta.png"
        alt=""
        aria-hidden="true"
        className="h-6.5 w-6.5 shrink-0 object-contain"
      />
      <span className="text-faint hidden flex-1 text-left md:inline">
        {ASK_AI_LABEL}
      </span>
      <kbd
        suppressHydrationWarning
        className="bg-surface-raised text-faint border-key pointer-events-none hidden shrink-0 rounded border px-1.5 py-0.5 font-mono text-[10px] leading-none opacity-0 transition-opacity group-hover:opacity-100 md:block"
      >
        {modKey}+K
      </kbd>
    </button>
  );
}
